export default "__VITE_ASSET__ryoQpxry__"